import { useDataFetch as useDataFetchCore } from '@core/js/hooks/useDataFetch/useDataFetch';

type TUseDataFetchProps = {
    fetch: (...args: unknown[]) => unknown;
    params?: unknown;
    onResponse?: (...args: unknown[]) => unknown;
    onError?: (...args: unknown[]) => unknown;
    initialData?: Record<string, unknown>;
    initialIsLoading?: boolean;
    shouldFetch?: (...args: unknown[]) => unknown;
};

export const useDataFetch = (data: TUseDataFetchProps) => useDataFetchCore(data as any);
